import { render } from "./CustomTagsAndFields.vue?vue&type=template&id=79bc3652"
import script from "./CustomTagsAndFields.vue?vue&type=script&lang=js"
export * from "./CustomTagsAndFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__